/** The roster table, or the empty state when nothing matches. The Type and
 *  rate columns show only when the API sent pay data for these rows. */
import { Users } from 'lucide-react';

import type { StaffMember } from '../../../api/staff';
import { PAY_RATE_ROLE_LABELS, PAY_RATE_ROLES } from '../pay-rates/pay-rate-format';

import StaffRosterRow from './StaffRosterRow';

const TH = 'px-4 py-3 text-center text-xs font-medium text-stone-600 dark:text-stone-400 uppercase';
const PAY_TH = TH.replace('px-4', 'px-3');

export default function StaffRosterTable({ rows }: { rows: StaffMember[] }) {
  if (rows.length === 0) {
    return (
      <div className="bg-white dark:bg-[#1a1f1c] rounded-lg border p-12 text-center">
        <Users className="mx-auto text-stone-400 mb-4" size={48} />
        <p className="text-stone-600 dark:text-stone-400">No staff found</p>
      </div>
    );
  }
  const showPay = rows.some((m) => m.currentRates !== undefined);
  return (
    <div className="bg-white dark:bg-[#1a1f1c] rounded-lg border overflow-x-auto">
      <table className="w-full min-w-[820px]">
        <thead className="bg-stone-50 dark:bg-[#1e2520] border-b">
          <tr>
            <th className="sticky left-0 z-10 bg-stone-50 dark:bg-[#1e2520] px-6 py-3 text-left text-xs font-medium text-stone-600 dark:text-stone-400 uppercase">
              Name
            </th>
            {showPay && (
              <>
                <th className={PAY_TH}>Type</th>
                {PAY_RATE_ROLES.map((role) => (
                  <th key={role} className={PAY_TH}>
                    {PAY_RATE_ROLE_LABELS[role]}
                  </th>
                ))}
              </>
            )}
            <th className={TH}>Workshops</th>
            <th className={TH}>Upcoming</th>
          </tr>
        </thead>
        <tbody className="divide-y">
          {rows.map((member) => (
            <StaffRosterRow key={member.id} member={member} showPay={showPay} />
          ))}
        </tbody>
      </table>
    </div>
  );
}
